// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 932) return "static/css/932.86401fe9b54e81539e26.lib.css";
	if (chunkId === 410) return "static/css/410.738e190921f1b24d852e.css";
	// return url for filenames based on template
	return undefined;
};